//EXTERNAL
import React from "react"
//COMPONENTS
import BouncingIcon from "../BouncingIcon"
//ASSETS
import phoneFrame from "../../assets/iphonex-frame.png"
import demoArticleHero from "../../assets/demo-article-hero.jpg"
import "./Article.css"

export default function ArticleDesktop(format, width) {
  /**
   * JA (31-08-23)
   * To increase the width of the device container, take the width param passed through the url, and add 80px for some margin space.
   */
  const deviceWidth = width + 80;
  return (
    <div className="min-vh-100 pb3">
      <div
        style={{
          width: deviceWidth || 380.73,
          height: 790.5
        }}
        className="phone-container relative center">
        <img layout="fixed" style={{ width: deviceWidth || 380, height: 790.5 }} src={phoneFrame} alt="iphone-frame" />
        <div
          style={{
            left: "6.13%",
            top: "6.8%",
            width: "87.8%",
            height: "92%",
            borderBottomRightRadius: "39px",
            borderBottomLeftRadius: "39px"
          }}
          className="phone-screen absolute bg-white overflow-y-scroll">
          <img
            src={demoArticleHero}
            style={{ height: "183px", width: "100%" }}
            alt={"article-header"}
          />
          <div className="article-content lh-copy serif">
            <h2 className="f5 tl mh3 mb1 lh-title">Stories are about to surpass feed sharing. Now what?</h2>
            <h4 className="f7 mv1 mh3 lh-title i navy">Stories are growing 15X faster than feeds, so behaviours must evolve</h4>
            <hr className="mh3" />
            <BouncingIcon />
            <div className="article-body athelas tj">
              <p className="mt1 mh2">
                We’re at the cusp of the visual communication era. Stories creation and consumption is up 842 percent since early 2016, according to consulting firm Block Party. Nearly a billion accounts across Snapchat, Instagram, WhatsApp, Facebook, and Messenger now create and watch these vertical, ephemeral slideshows. And yesterday, Facebook chief product officer Chris Cox showed a chart detailing how “the Stories format is on a path to surpass feeds as the primary way people share things
                with their friends sometime next year.”
              </p>
              <p className="mt1 mh2">The repercussions of this medium shift are vast. Users now consider how every moment could be glorified and added to the narrative of their day. Social media platforms are steamrolling their old designs to highlight the camera and people’s Stories. And advertisers must rethink their message not as a headline, body text, and link, but as a background, overlays, and a feeling that lingers even if viewers don’t click through.</p>
              <div className="ad-creative flex flex-row justify-center">{format}</div>
              <p className="mt3 mh2">
                WhatsApp’s Stories now have over 450 million daily users. Instagram’s have over 300 million. Facebook Messenger’s had 70 million in September. And Snapchat as a whole just reached 191 million, about 150 million of which use Stories according to Block Party. With 970 million accounts, it’s the format of the future. Block Party calculates that Stories grew 15X faster than feeds from Q2. Users now consider how every moment could be glorified and added to the narrative of their day.
                Social media platforms are steamrolling their old designs to highlight the camera and people’s Stories.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
